<app-loading *ngIf="contentReady"></app-loading>
<div class="invoice-container">
    <div class="invoice-header">

        <img src="/assets/logo color.png" alt="Company Logo">
        <h1>{{'details' | transloco}}</h1>
        <p>{{'invoice' | transloco}}: #{{invoiceId}}</p>
        <p>{{'Date' | transloco}}: {{date}}</p>
    </div>

    <div class="invoice-details row">

        <div class="col-sm-12 col-md-12">
            <h3>{{'Info' | transloco}}:</h3>
            <p>{{'yourname' | transloco}} :{{clientname}}</p>
            <p>{{'yournumber' | transloco}}:{{firstphone}}</p>
            <p>{{'yoursecnumber' | transloco}}:{{secphone}}</p>
            <p>{{ "address" | transloco }}:{{address}}</p>
            <p class="noPrint"><span style="color: #e91e63;">{{ 'note' | transloco }} :</span>{{note}}</p>
            <!-- <p><span>Delivery Hero:{{delivery_hero}}</span></p> -->
        </div>
    </div>

    <table class="invoice-table">
        <thead>
            <tr>
                <th>{{ "Product" | transloco }}</th>
                <th>{{ "quantity" | transloco }}</th>
                <th>{{ "Unit Price" | transloco }}</th>
                <th>{{'total' | transloco}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let product of products; let i = index">
                <td>{{products[i]}}</td>
                <td>{{qty[i]}}</td>
                <td>{{prices[i]}} {{'egpe' | transloco}}</td>
                <td>{{prices[i] * qty[i]}} {{'egpe' | transloco}}</td>
            </tr>

        </tbody>
        <tfoot>
            <tr>
                <td colspan="3">{{ "subtotal" | transloco }}</td>
                <td>{{this.sumprices}} {{'egpe' | transloco}}</td>
            </tr>

            <tr>
                <td colspan="3">{{'delivery fees' | transloco}}</td>
                <td>{{deliveryfees}} {{'egpe' | transloco}}</td>
            </tr>
            <tr class="total">
                <td colspan="3"> {{ "discount" | transloco }}</td>
                <td>{{discount}} {{'egpe' | transloco}}</td>
            </tr>
            <tr>
                <td colspan="3">{{'total' | transloco}}</td>
                <td>{{this.sumprices + deliveryfees - discount}} {{'egpe' | transloco}}</td>
            </tr>
        </tfoot>
    </table>

    <div class="invoice-footer">
        @if(qrPath != null){
        <div class="offer">
            <p> اعمل اسكان و احصل علي
                <br>
                شحن مجاني لنفس الاوردر
            </p>
            <a [href]="link" target="_blank" rel="noopener noreferrer">

                <img [src]="fixImageUrl(qrPath)" alt="QR Code">
            </a>
        </div>
        }
        <p>Thank For Choosing {{pagename}}!</p>


    </div>

</div>